import type { AdminOrderRow } from './types'

// forwarding_status, in lifecycle order. The backend rejects anything else.
export const ORDER_STATUSES = ['draft','quoted','awaiting_payment','paid','label_pending','label_ready','in_transit','delivered','exception','cancelled'] as const

export const ORDER_LABELS: Record<string,string> = {
  draft:'Draft', quoted:'Quoted', awaiting_payment:'Awaiting payment', paid:'Paid',
  label_pending:'Label pending', label_ready:'Label ready', in_transit:'In transit',
  delivered:'Delivered', exception:'Exception', cancelled:'Cancelled',
}

// Where an order sits relative to the warehouse — the view the staff queue
// cannot give, because it drops anything not currently in the building.
export function whereIsIt(order: AdminOrderRow) {
  if (order.archivedAt) return { label: 'Archived', tone: 'idle' }
  if (order.status === 'cancelled') return { label: 'Cancelled', tone: 'idle' }
  if (order.cancellationPending || order.status === 'exception') return { label: 'On hold', tone: 'waiting' }
  if (order.shippedAt) return { label: 'Shipped to customer', tone: 'done' }
  if (order.receivedAt) return { label: 'At warehouse', tone: 'here' }
  if (order.authorized) return { label: 'Awaiting arrival', tone: 'waiting' }
  return { label: 'Not paid', tone: 'idle' }
}
